export const AllData = [
  {
    id: 1,
    name: "social-media-dashboard-with-theme-switcher-master",
    image: "./fm/social.jpg",
    github:
      "https://github.com/Imranh21/Frontend-Mentor-Challenges/tree/master/social-media-dashboard-with-theme-switcher-master",
    link: "https://smdt.netlify.app"
  },
  {
    id: 2,
    name: "intro-component-with-signup-form-master",
    image: "./fm/intro.jpg",
    github:
      "https://github.com/Imranh21/Frontend-Mentor-Challenges/tree/master/intro-component-with-signup-form-master",
    link: "https://sad-einstein-955eb8.netlify.app"
  },
  {
    id: 3,
    name: "insure-landing-page-master",
    image: "./fm/ensure.jpg",
    github:
      "https://github.com/Imranh21/Frontend-Mentor-Challenges/tree/master/insure-landing-page-master",
    link:
      "https://github.com/Imranh21/Frontend-Mentor-Challenges/tree/master/insure-landing-page-master"
  },
  {
    id: 4,
    name: "huddle-landing-page-with-single-introductory-section-master",
    image: "./fm/huddle1.jpg",
    github:
      "https://github.com/Imranh21/Frontend-Mentor-Challenges/tree/master/huddle-landing-page-with-single-introductory-section-master",
    link:
      "https://github.com/Imranh21/Frontend-Mentor-Challenges/tree/master/huddle-landing-page-with-single-introductory-section-master"
  },
  {
    id: 5,
    name: "huddle-landing-page-with-curved-sections-master",
    image: "./fm/huddle2.jpg",
    github:
      "https://github.com/Imranh21/Frontend-Mentor-Challenges/tree/master/huddle-landing-page-with-curved-sections-master",
    link: "https://fm1.netlify.app/"
  },
  {
    id: 6,
    name: "huddle-landing-page-with-alternating-feature-blocks-master",
    image: "./fm/huddle3.jpg",
    github:
      "https://github.com/Imranh21/Frontend-Mentor-Challenges/tree/master/huddle-landing-page-with-alternating-feature-blocks-master",
    link: "https://epic-mestorf-1f359e.netlify.app/"
  },
  {
    id: 7,
    name: "fylo-landing-page-with-two-column-layout-master",
    image: "./fm/fylo1.jpg",
    github:
      "https://github.com/Imranh21/Frontend-Mentor-Challenges/tree/master/fylo-landing-page-with-two-column-layout-master",
    link: "https://flyo-landing.netlify.app"
  },
  {
    id: 8,
    name: "fylo-dark-theme-landing-page-master",
    image: "./fm/fylo2.jpg",
    github:
      "https://github.com/Imranh21/Frontend-Mentor-Challenges/tree/master/fylo-dark-theme-landing-page-master",
    link: "https://flyo-landing-dark.netlify.app"
  },
  {
    id: 9,
    name: "four-card-feature-section-master",
    image: "./fm/fourcard.jpg",
    github:
      "https://github.com/Imranh21/Frontend-Mentor-Challenges/tree/master/four-card-feature-section-master",
    link: "https://fm3.netlify.app"
  },
  {
    id: 10,
    name: "Single-price-grid-component-master",
    image: "./fm/single.jpg",
    github:
      "https://github.com/Imranh21/Frontend-Mentor-Challenges/tree/master/Single-price-grid-component-master",
    link: "https://fm2.netlify.app/"
  }
];
